import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 试卷列表
  exampage(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/exam/page',
      method: 'GET',
      params: arg
    })
  },

  list(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/exam/list',
      method: 'GET',
      params: arg
    })
  },
  // 历史考试列表
  examhistory(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/exam/history/page',
      method: 'GET',
      params: arg
    })
  },
  // 试卷下试题列表
  examquestion(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/exam/question/' + arg,
      method: 'GET'
    })
  },
  // 历史考试试题列表
  examhistoryquestion(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/exam/history/question',
      method: 'GET',
      params: arg
    })
  },
  // 提交答案
  examscore(arg) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/exam/score',
      method: 'post',
      data: arg
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/exam/index.js